
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.864 18.191a1.783 1.783 0 00-2.474 0l-8.133 8.22a.89.89 0 00-.001 1.252c.164.166.388.26.621.26h.873a.88.88 0 01.875.884v4.424c0 .976.784 1.769 1.75 1.769h1.75a1.76 1.76 0 001.75-1.77v-3.538c0-.977.784-1.77 1.75-1.77s1.75.793 1.75 1.77v3.539c0 .976.784 1.769 1.75 1.769h1.75a1.76 1.76 0 001.75-1.77v-4.423a.88.88 0 01.875-.884h.875a.88.88 0 00.875-.885.89.89 0 00-.257-.626l-8.129-8.22zm30.879 8.22l-8.133-8.22a1.783 1.783 0 00-2.474 0l-8.13 8.22a.89.89 0 00-.002 1.252.87.87 0 00.62.26h.876a.88.88 0 01.875.884v4.424c0 .976.784 1.769 1.75 1.769h1.75a1.76 1.76 0 001.75-1.77v-3.538c0-.977.784-1.77 1.75-1.77s1.75.793 1.75 1.77v3.539c0 .976.784 1.769 1.75 1.769h1.75a1.76 1.76 0 001.75-1.77v-4.423a.88.88 0 01.875-.884h.875a.88.88 0 00.875-.885.89.89 0 00-.257-.626zM22.75 15.538c0 .977.784 1.77 1.75 1.77h1.75a1.76 1.76 0 001.75-1.77v-4.423a.88.88 0 01.875-.885h.875a.881.881 0 00.877-.883.894.894 0 00-.257-.628L22.237.498a1.787 1.787 0 00-2.474 0l-8.132 8.22a.89.89 0 00-.002 1.251c.164.166.388.26.621.26h.875a.88.88 0 01.875.885v4.423c0 .977.784 1.77 1.75 1.77h1.75a1.76 1.76 0 001.75-1.77v-3.539c0-.976.784-1.769 1.75-1.769s1.75.793 1.75 1.77v3.538z"}})])
          )
        }
      }
    